import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.verify');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-verify',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminVerifyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public gates: any[] = [];
    public page: number = 1;
    public lastpage: number = 1;

    public statusFilter: string = '';
    public statuses: string[] = ['', 'pending', 'approved', 'rejected', 'revision', 'hold'];
    public statusLabels: any = { '': '전체', pending: '대기', approved: '승인', rejected: '반려', revision: '보정', hold: '보류' };

    public selectedGate: any = null;
    public actionDecision: string = '';
    public actionNote: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load(page: number = 1) {
        this.loading = true;
        this.page = page;
        await this.service.render();

        const { code, data } = await wiz.call("verification_list", {
            status: this.statusFilter,
            page: this.page,
        });

        if (code === 200 && data) {
            this.gates = data.list || [];
            this.lastpage = data.lastpage || 1;
        }
        this.loading = false;
        await this.service.render();
    }

    public async filterStatus(s: string) {
        this.statusFilter = s;
        await this.load(1);
    }

    public showDetail(gate: any) {
        this.selectedGate = gate;
        this.actionDecision = '';
        this.actionNote = '';
        this.service.render();
    }

    public closeDetail() {
        this.selectedGate = null;
        this.service.render();
    }

    public async submitAction() {
        if (!this.actionDecision || !this.selectedGate) return;
        const { code } = await wiz.call("verification_action", {
            gate_id: this.selectedGate.id,
            action: this.actionDecision,
            note: this.actionNote,
        });
        if (code === 200) {
            this.selectedGate = null;
            await this.load(this.page);
        } else {
            await this.service.alert.show({ title: '오류', message: '처리에 실패했습니다.', action: '확인' });
        }
    }

    public statusColor(s: string): string {
        const colors: any = {
            pending: 'bg-yellow-100 text-yellow-700',
            approved: 'bg-green-100 text-green-700',
            rejected: 'bg-red-100 text-red-700',
            revision: 'bg-orange-100 text-orange-700',
            hold: 'bg-gray-100 text-gray-500',
        };
        return colors[s] || 'bg-gray-100 text-gray-500';
    }

    public pages(): number[] {
        const arr: number[] = [];
        for (let i = 1; i <= this.lastpage; i++) arr.push(i);
        return arr;
    }
}

export default PortalNrichadminAdminVerifyComponent;